import { render, staticRenderFns } from "./addNewGuide.vue?vue&type=template&id=027284fe&scoped=true&"
import script from "./addNewGuide.vue?vue&type=script&lang=js&"
export * from "./addNewGuide.vue?vue&type=script&lang=js&"
import style0 from "./addNewGuide.vue?vue&type=style&index=0&id=027284fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027284fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027284fe')) {
      api.createRecord('027284fe', component.options)
    } else {
      api.reload('027284fe', component.options)
    }
    module.hot.accept("./addNewGuide.vue?vue&type=template&id=027284fe&scoped=true&", function () {
      api.rerender('027284fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addNewGuide.vue"
export default component.exports